(function() {
    'use strict';

    angular.module('GorillaBoy.DocumentViewer')
    .directive('documentVersionFeedback', ['SourceConstant', 'SignalProvider', '$rootScope', 'DocumentUtilities', 'DocumentStateService', 'AppConstants', '$translate', '$filter',
        function(SourceConstant, SignalProvider, $rootScope, DocumentUtilities, DocumentStateService, AppConstants, $translate, $filter) {
            return {
                restrict: 'E',
                templateUrl: './document-viewer/feedback_list_view.html',
                link: function(scope, element, attrs) {

                    scope.cancelFeedback = function(feedbackObj) {
                        feedbackObj.inReplyMode = false;
                        feedbackObj.inEditMode = false;
                    };

                    scope.feedbackFilter = function(feedbackObj) {
                        return feedbackObj.isVisible;
                    };

                    scope.activeVersionId = DocumentStateService.activeVersionId;
                    scope.isAnnotation = DocumentUtilities.isAnnotation;
                    scope.feedback = DocumentStateService.feedback;
                    scope.DOC_LEVEL = AppConstants.DOC_LEVEL;
                    scope.isResolved = DocumentUtilities.isResolved;

                    scope.getContributorFullName = function(contributor) {
                        if (!contributor) {
                            return;
                        }
                        return $translate.instant('RIGHT_NAV.PERSON_NAME', {
                            givenName: $rootScope.escapeHTML(contributor.GivenName),
                            surname: $rootScope.escapeHTML(contributor.Surname)
                        });
                    };
                }
            };
        }
    ]);
}());
